import type { SocialProviderConfig } from '@/services/interfaces/Auth';
import { createProviderConfig } from './socialProviders';

// 当前应用的社交登录提供者配置
export const appSocialProviders: SocialProviderConfig[] = [
  createProviderConfig('apple', {
    name: 'Apple',
    enabled: true,
  }),
  createProviderConfig('google-oauth2', {
    name: 'Google',
    enabled: true,
  }),
];

// 获取当前应用启用的提供者
export const getAppEnabledProviders = (): SocialProviderConfig[] => {
  return appSocialProviders.filter(provider => provider.enabled);
};

// 应用特定的Auth0配置
export const getAppAuth0Config = () => {
  return {
    domain: import.meta.env.VITE_AUTH0_DOMAIN || '',
    clientId: import.meta.env.VITE_AUTH0_CLIENT_ID || '',
    // 🔑 使用专门的回调页面，避免与登录页面冲突
    redirectUri: import.meta.env.VITE_AUTH0_REDIRECT_URI || `${window.location.origin}/auth/callback`,
    audience: import.meta.env.VITE_AUTH0_AUDIENCE,
    scope: import.meta.env.VITE_AUTH0_SCOPE || 'openid profile email',
  };
};
